
import React from 'react'

export interface ImgParams {
  src?: string;
}

interface AvatarImageProps {
  imgParams: ImgParams;
  messageViewType?: string;
  nickname?: string;
}

const AvatarImage: React.FC<AvatarImageProps> = ({ imgParams, messageViewType, nickname = '' }) => {
  if (messageViewType !== 'bubble') return null;

  const src = imgParams?.src?.trim();
  const hasAvatar = !!src && !src.includes('/defres/operator/image/picture/1x1.gif');
  if (!hasAvatar) return null

  return (
    <div className="operator-img">
      <div className="operator-img_content">
        <img
          src={src}
          alt={`${nickname} picture`}
          lang="en"
        />
      </div>
    </div>
  );
};

export default AvatarImage;
